// Tour step definitions for EQUIPR CORE
// Each step can have:
// - requiresAdmin: boolean - only show for admin users
// - requiresIndustry: string - only show for specific industry ('earthmoving' or 'crane_hire')

export const MAIN_TOUR_STEPS = [
  {
    id: 'welcome',
    target: '[data-testid="admin-dashboard"]',
    title: 'Welcome to EQUIPR',
    content: 'This is your dashboard - your overview of jobs, dockets, and business activity.',
    placement: 'center',
    spotlightPadding: 0,
    disableOverlay: true
  },
  {
    id: 'schedule',
    target: '[href="/schedule"]',
    title: 'Schedule',
    content: 'Create and manage jobs - allocate your team.',
    placement: 'right'
  },
  {
    id: 'customers',
    target: '[href="/customers"]',
    title: 'Customers',
    content: 'Manage your customers and their job sites here.',
    placement: 'right'
  },
  {
    id: 'suppliers',
    target: '[href="/suppliers"]',
    title: 'Suppliers',
    content: 'Manage your suppliers and subcontractors.',
    placement: 'right'
  },
  {
    id: 'equipment',
    target: '[href="/equipment"]',
    title: 'Assets',
    content: 'Manage equipment and attachments.',
    placement: 'right'
  },
  {
    id: 'operators',
    target: '[href="/workers"]',
    title: 'Workers',
    content: 'Add your field workers - they\'ll submit dockets via the mobile portal.',
    placement: 'right'
  },
  {
    id: 'tips-materials',
    target: '[href="/tips-materials"]',
    title: 'Tips & Materials',
    content: 'Manage material yards, tips, and quarries for tracking pickups and disposals.',
    placement: 'right',
    requiresIndustry: 'earthmoving'
  },
  {
    id: 'dockets',
    target: '[href="/dockets"]',
    title: 'Dockets',
    content: 'Review submitted dockets, approve and prepare for invoicing.',
    placement: 'right'
  },
  {
    id: 'compliance',
    target: '[href="/compliance"]',
    title: 'Compliance',
    content: 'Track certifications, licences, and document expiry dates for your team and equipment.',
    placement: 'right'
  },
  {
    id: 'timesheets',
    target: '[href="/timesheets"]',
    title: 'Timesheets',
    content: 'Review and manage operator timesheets and hours worked.',
    placement: 'right'
  },
  {
    id: 'messages',
    target: '[href="/chat"]',
    title: 'Messages',
    content: 'Send and receive messages with your operators in the field.',
    placement: 'right'
  },
  {
    id: 'forms',
    target: '[href="/forms"]',
    title: 'Forms',
    content: 'Create and manage custom forms for safety checks, inspections, and more.',
    placement: 'right'
  },
  {
    id: 'standard_reports',
    target: '[href="/reports"]',
    title: 'Reports',
    content: 'Generate reports for jobs, revenue, operator performance, and compliance.',
    placement: 'right'
  },
  {
    id: 'data-management',
    target: '[href="/data-management"]',
    title: 'Data Management',
    content: 'Configure equipment types, compliance types, worker types and more.',
    placement: 'right',
    requiresAdmin: true
  },
  {
    id: 'data-import',
    target: '[href="/data-import"]',
    title: 'Data Import',
    content: 'Import customers, equipment, and other data from spreadsheets.',
    placement: 'right',
    requiresAdmin: true
  },
  {
    id: 'settings',
    target: '[data-testid="settings-nav-btn"]',
    fallbackTarget: '[href="/settings"]',
    title: 'Settings',
    content: 'Customize your company profile, accounting integration, users, billing and more.',
    placement: 'bottom',
    requiresAdmin: true
  },
  {
    id: 'help',
    target: '[data-testid="help-nav-btn"]',
    fallbackTarget: '[href="/help"]',
    title: 'Help Centre',
    content: 'Access training guides, video walkthroughs, and support resources anytime.',
    placement: 'bottom'
  },
  {
    id: 'complete',
    target: '[data-testid="admin-dashboard"]',
    title: "You're Ready!",
    content: 'Explore on your own, or visit the Help Centre for step-by-step guides on specific tasks.',
    placement: 'center',
    spotlightPadding: 0,
    disableOverlay: true,
    isLast: true
  }
];

// Filter tour steps based on user role and tenant industry
export const getFilteredTourSteps = (isAdmin, industry) => {
  return MAIN_TOUR_STEPS.filter(step => {
    // Check admin requirement
    if (step.requiresAdmin && !isAdmin) {
      return false;
    }
    
    // Check industry requirement
    if (step.requiresIndustry && step.requiresIndustry !== industry) {
      return false;
    }
    
    return true;
  });
};

export const TOUR_STORAGE_KEY = 'equipr_tour_state';

export const getDefaultTourState = () => ({
  mainTourCompleted: false,
  mainTourSkipped: false,
  lastTourStep: 0
});
